// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
import ChatIcon from "@assets/svg/ChatIcon";

const YourTeamMembers = () => {
  return (
    <div className="flex flex-col h-48 bg-white rounded-md p-3">
      <div className="flex items-center justify-between border-b pb-2">
        <span className="font-bold text-sm text-primary">
          Your Team Members (12)
        </span>
        <button className="text-xs text-blue-500 font-semibold">
          View All
        </button>
      </div>
      <div className="flex flex-col overflow-y-scroll no-scrollbar gap-3 py-4">
        {Array.from({ length: 10 })?.map(() => {
          return (
            <div className="flex items-center justify-between">
              <div className="flex gap-3 items-center">
                <img src={ProfileImg} className="h-8 w-8 rounded-full" />
                <div className="flex flex-col">
                  <span className="text-xs font-medium">Ronald Richards</span>
                  <span className="text-xs text-light-black">
                    Manager
                  </span>
                </div>
              </div>
              <ChatIcon className={"h-5 w-5"} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YourTeamMembers;
